var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("monitor " + _vm.size + " " + _vm.classes)},[_c('c-img',{class:("" + _vm.size),attrs:{"src":"img/kb-screen.png"}}),_c('div',{class:"screenshot-overlay",style:(_vm.screenshotBackgroundStyle)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }